<template>
  <a-form :form="form" id="form">
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <a-form-item label="">
          <font style="color:rgba(0, 0, 0, 0.85);font-size: 14px;">File Description</font>
          <a-input v-model="fungsi" :required="true" />
        </a-form-item>
        <a-form-item label="Choose File">
          <a-upload accept=".pdf" :showUploadList="false" :beforeUpload="beforeUpload"
            v-decorator="['upload', { valuePropName: 'push' }]" :loading="true">
            <a-button icon="upload" :loading="loading.upload" :disabled="loading.upload">
              &nbsp;Select File
            </a-button>
          </a-upload>
        </a-form-item>
      </a-col>
    </a-row>
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <a-card :loading="uploading" class="margin-top margin-bottom" title="Supporting File">
          <a-list itemLayout="horizontal" :loading="uploading" :dataSource="existing"
            v-if="mode === 'Edit' && existing.length > 0">
            <a-list-item slot="renderItem" slot-scope="item">
              <a-list-item-meta>
                <div slot="title" class="m-display-flex space-between align-middle">
                  <h3>{{ item.deskripsi }}</h3>
                  <a-button @click="handleRemoveExisting(item.id_pdlk_file)" type="danger"
                    :loading="loading.delete && loading.key == item.id_pdlk_file"
                    :disabled="loading.delete && loading.key != item.id_pdlk_file">Delete</a-button>
                </div>
                <template slot="description">
                  <span :class="getScreen ? 'm-list-dots' : ''">{{ item.nama_file }}</span>
                </template>
                <!-- <img class="m-image-icon" slot="avatar" src="@/assets/icon/pdf_ico.png" /> -->
              </a-list-item-meta>
            </a-list-item>
          </a-list>
          <a-list itemLayout="horizontal" :loading="uploading" :dataSource="push" v-if="push.length > 0">
            <a-list-item slot="renderItem" slot-scope="item">
              <a-list-item-meta>
                <div slot="title" class="m-display-flex space-between align-middle">
                  <h3>{{ item.deskripsi }}</h3>
                  <a-button @click="handleRemove('new', item.id_pdlk_file)" type="danger"
                    :loading="loading.delete && loading.key == item.id_pdlk_file"
                    :disabled="loading.delete && loading.key != item.id_pdlk_file">Delete</a-button>
                </div>
                <template slot="description">
                  <span :class="getScreen ? 'm-list-dots' : ''">{{ item.nama_file }}</span>
                </template>
                <!-- <img class="m-image-icon" slot="avatar" src="@/assets/icon/pdf_ico.png" /> -->
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </a-card>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { mapGetters } from "vuex";
import GlobalMethod from "@/mixins/GlobalMethod";
import _ from "lodash";
export default {
  name: "Lampiran",
  mixins: [GlobalMethod],
  props: {
    mode: String,
    id_pdlk: String,
    isDraft: Boolean,
    listDokumen: {},
    collectData: {},
  },
  data() {
    return {
      file: "",
      uploading: false,
      push: [],
      existing: [],
      deleteExistingDoc: [],
      fungsi: "",
      loading: {
        upload: false,
        delete: false,
        key: "",
      }
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    if (this.mode === "Edit") {
      if (this.listDokumen.dokumenPendukung) {
        this.existing = this.listDokumen.dokumenPendukung;
      } else {
        this.existing = this.listDokumen;
      }
      if (this.listDokumen.newDoc) {
        this.push = this.listDokumen.newDoc;
      }
      if (this.listDokumen.deleteExistingDoc) {
        this.deleteExistingDoc = this.listDokumen.deleteExistingDoc;
      }
    }
    if (this.mode === "Create") {
      if (this.listDokumen != undefined) {
        if (this.listDokumen.dokumenPendukung != undefined) {
          if (this.listDokumen.dokumenPendukung.length > 0) {
            this.push = this.listDokumen.dokumenPendukung;
          }
        }
        if (this.listDokumen.newDoc) {
          this.push = this.listDokumen.newDoc;
        }
      }
    }
  },
  computed: {
    ...mapGetters(["getScreen", "getAuth"])
  },
  methods: {
    handleRemoveExisting(id) {
      // const index = this.existing.indexOf(id);
      // //untuk list Delete
      // const delPush = this.existing.filter(item => item.id_file === id);
      // this.deleteExistingDoc.push(delPush);
      // //untuk list View
      // const newPush = this.existing.filter(item => item.id_file !== id);
      // this.existing = newPush;
      this.handleRemove("existing", id)
    },
    handleRemove(jns, idfile) {
      this.loading.delete = true;
      this.loading.key = idfile;
      this.asyncAxiosDelete(
        "lap_kegiatan_pd/del_lampiran",
        "application/json",
        this.getAuth,
        {
          id: idfile,
        }
      )
        .then(() => {
          if (jns == "existing") {
            const newPush = this.existing.filter(item => item.id_pdlk_file !== idfile);
            this.existing = newPush;
          } else {
            const newPush = this.push.filter(item => item.id_pdlk_file !== idfile);
            this.push = newPush;
          }
          this.loading.delete = false;
          this.loading.key = "";
        })
        .catch((err) => {
          console.log(err)
          this.loading.delete = false;
          this.loading.key = "";
        });
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 2) {
        this.displayMessage("large-file-2mb");
      } else if (this.fungsi === "") {
        this.displayMessage("error-emptyDoc");
      } else {
        Event.$emit("uploadFIlesLapKegPD", {
          file,
          deskripsi: this.fungsi,
          nama_file: file.name
        });

        // let data = new FormData();
        // data.append("id_sppd", this.collectData.informasi.id_sppd);
        // data.append("tgl_buat", this.collectData.informasi.tgl_buat);
        // data.append("lokasi", this.collectData.informasi.lokasi);
        // data.append("file_description", this.fungsi);
        // data.append("dokumen", this.file);

        // this.loading.upload = true;
        // console.log("jsjddj")
        // this.asyncAxiosPost("lap_kegiatan_pd/add_lampiran", "formdata", this.getAuth, data)
        //   .then(() => {
        //   console.log("jos")
        //   this.push = [
        //     ...this.push,
        //     {
        //       file,
        //       deskripsi: this.fungsi,
        //       nama_file: file.name
        //     }
        //   ];

        //   this.fungsi = "";
        //   this.loading.upload = false;
        // })
        //   .catch(() => {
        //   console.log("jos dddd")
        //   this.loading.upload = false;
        // });
        return false;
      }
    },
    handleRef() {
      Event.$emit("updateDokumen", {
        dokumenPendukung: this.push,
        deleteExistingDoc: this.deleteExistingDoc
      });
    },
    handleRefBack() {
      Event.$emit("newDokumen", {
        dokumenPendukung: this.existing,
        deleteExistingDoc: this.deleteExistingDoc,
        newDoc: this.push
      });
    },
    uploadFilesProcess(val) {
      let data = new FormData();
      if (this.id_pdlk)
        data.append("id_pdlk", this.id_pdlk);
      data.append("id_sppd", this.collectData.informasi.id_sppd);
      data.append("tgl_buat", this.collectData.informasi.tgl_buat);
      data.append("lokasi", this.collectData.informasi.lokasi);
      data.append("file_description", val.deskripsi);
      data.append("dokumen", val.file);

      this.loading.upload = true;
      this.asyncAxiosPost("lap_kegiatan_pd/add_lampiran", "formdata", this.getAuth, data)
        .then((response) => {
          let files = val.file
          this.push = [
            ...this.push,
            {
              files,
              deskripsi: val.deskripsi,
              nama_file: val.nama_file,
              id_pdlk_file: response.doc[0].id_pdlk_file,
            }
          ];
          this.fungsi = "";
          this.loading.upload = false;
        })
        .catch((err) => {
          console.log(err)
          this.loading.upload = false;
        });
    }
  },
  mounted() {
    Event.$on("uploadFIlesLapKegPD", this.uploadFilesProcess);
  },
  destroyed() {
    Event.$off("uploadFIlesLapKegPD", this.uploadFilesProcess);
  }
};
</script>

<style></style>